module.exports = __webpack_public_path__ + "static/media/undp_1.ba2b6c91.jpg";